import {
  IMusicProductPhysicalSettlementInfoForm,
  IMusicProductPhysicalSettlementInfoPerTrackContractForm,
} from "services/music-product-physical/types/form";
import {
  IMusicProductPhysicalSettlementInfoPerTrackContractResponse,
  IMusicProductPhysicalSettlementInfoResponse,
} from "services/music-product-physical/types/query";
import { formatDateToInput } from "utils/global/date.utils";

export const settlementInfoQueryToForm = (
  settlementResponse: IMusicProductPhysicalSettlementInfoResponse | null
): IMusicProductPhysicalSettlementInfoForm => ({
  perTrackSettlement: settlementResponse?.perTrackSettlement ?? false,
  contracts:
    settlementResponse?.contracts.map((c) => ({
      ...c,
      startDate: formatDateToInput(c.startDate),
      endDate: c.endDate ? formatDateToInput(c.endDate) : null,
    })) ?? [],
  perTrackContracts: groupContractsByTrack(
    settlementResponse?.perTrackContracts ?? []
  ),
});

export const groupContractsByTrack = (
  data: IMusicProductPhysicalSettlementInfoPerTrackContractResponse[]
): IMusicProductPhysicalSettlementInfoPerTrackContractForm[] => {
  const groupedMap = new Map<string, any>();

  data.forEach((contract) => {
    const { trackId, title, ...contractDetails } = {
      ...contract,
      startDate: formatDateToInput(contract.startDate),
      endDate: contract.endDate ? formatDateToInput(contract.endDate) : null,
    };

    if (!groupedMap.has(trackId)) {
      groupedMap.set(trackId, {
        title: title,
        trackId,
        contracts: [],
      });
    }

    groupedMap.get(trackId).contracts.push(contractDetails);
  });

  return Array.from(groupedMap.values());
};
